// extracted by mini-css-extract-plugin
module.exports = {"main":"ParserDevelopmentTool_main__-sGFv"};